module.exports = __webpack_public_path__ + "img/Israel_Chemicals_Limited.ff19a81c.svg";